module.exports = __webpack_public_path__ + "static/numbers-3-2-c8f270f7145d1041953255125293d1a4.png";